import useOnboardingPortalStore from "../OnboardingPortal.Store";
import Modal from "../../../components/modal/Modal";
import { useEffect, useState } from "react";
import { useJwtToken } from "@me8eon/react_authentication";
import { useTranslation } from "@me8eon/translation";
import ActivityLogScreen from "./ActivityLogScreen";
import {
    EonUiButton,
    EonUiIcon,
    EonUiInput,
} from "@eon-ui/eon-ui-components-react";
import OnboardingPortalLoader from "../components/OnboardingPortalLoader";

const ReviewQnAModal = () => {
    const t = useTranslation();
    const jwt = useJwtToken();
    const {
        showReviewQnA,
        reviewQnAData,
        resetReviewQnA,
        handleReviewQnA,
        isSubmittingReviewQnA,
    } = useOnboardingPortalStore();
    const [reviewerNotes, setReviewerNotes] = useState<string>("");

    useEffect(() => {
        setReviewerNotes("");
    }, [showReviewQnA]);

    const handleEmailQnAOwner = () => {
        const recipient = reviewQnAData?.owner || "";
        const subject = `Regarding Onboarding your QnA (${reviewQnAData?.question || "Untitled"}) in MyHelp`;
        const body = `Dear QnA Owner,\n\nThis is regarding the onboarding of your QnA:\n\nQnA ID: ${reviewQnAData?.id}\nQuestion: ${reviewQnAData?.question}\n\nPlease review and provide necessary information.\n\nBest regards`;
        const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        window.location.href = mailtoLink;
    };
    return (
        <>
            <Modal
                toggleModal={showReviewQnA}
                closeModal={resetReviewQnA}
                isCloseIcon={false}
                closeOnBackdrop={false}
                modalClass="review-modal"
            >
                <div
                    style={{
                        position: "relative",
                        display: "flex",
                        flexDirection: "column",
                        gap: 12,
                        padding: 20,
                    }}
                >
                    {isSubmittingReviewQnA && <OnboardingPortalLoader />}
                    <div className="onboarding-portal--header">
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: 12,
                            }}
                        >
                            <h1 className="onboarding-portal--header--heading">
                                {t(
                                    `onboardingPortal.modalLabel.reviewQnATitle`
                                )}
                            </h1>
                            <div style={{ marginLeft: "auto" }}>
                                <ActivityLogScreen
                                    key={`qna-activity-log-${reviewQnAData?.id}`}
                                    entityType="qna"
                                    entityData={reviewQnAData}
                                />
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    gap: "8px",
                                    fontSize: "18px",
                                    color: "#1E1E1E",
                                    fontWeight: "medium",
                                    // marginLeft: "auto",
                                    cursor: "pointer",
                                }}
                                onClick={handleEmailQnAOwner}
                            >
                                <EonUiIcon
                                    name="notification"
                                    scheme="red500"
                                />
                                <span>
                                    {t(`onboardingPortal.modalLabel.mail`)}{" "}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 12,
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(`onboardingPortal.modalLabel.category`)}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {reviewQnAData?.category}
                            </span>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(`onboardingPortal.modalLabel.question`)}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {reviewQnAData?.question}
                            </span>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(`onboardingPortal.modalLabel.answer`)}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {reviewQnAData?.answer}
                            </span>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(
                                    `onboardingPortal.modalLabel.companiesAllowed`
                                )}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {reviewQnAData?.companiesAllowed.join(", ")}
                            </span>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 4,
                            }}
                        >
                            <span
                                style={{
                                    color: "#666666",
                                    fontSize: "14px",
                                }}
                            >
                                {t(
                                    `onboardingPortal.modalLabel.companiesRestricted`
                                )}
                            </span>
                            <span
                                style={{
                                    color: "#1E1E1E",
                                    fontSize: "20px",
                                    fontWeight: "medium",
                                }}
                            >
                                {reviewQnAData?.companiesRestricted.join(", ")}
                            </span>
                        </div>
                    </div>
                    <div>
                        <EonUiInput
                            size="small"
                            style={{
                                marginTop: 8,
                                marginBottom: 8,
                            }}
                            placeholder="Reviewer Notes"
                            value={reviewerNotes || ""}
                            onValueChanged={(e) =>
                                setReviewerNotes(e.target.value)
                            }
                            textarea
                            rows={2}
                            label="Comments"
                        />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: 8,
                            alignItems: "center",
                        }}
                    >
                        <EonUiButton
                            rank="primary"
                            size="small"
                            text={t("onboardingPortal.approveBtn")}
                            disabled={!reviewerNotes}
                            onClick={() => {
                                handleReviewQnA(
                                    jwt,
                                    reviewQnAData?.id || "",
                                    "approved",
                                    reviewerNotes || ""
                                );
                            }}
                        />
                        <EonUiButton
                            rank="secondary"
                            size="small"
                            text={t("onboardingPortal.rejectBtn")}
                            disabled={!reviewerNotes}
                            onClick={() => {
                                handleReviewQnA(
                                    jwt,
                                    reviewQnAData?.id || "",
                                    "rejected",
                                    reviewerNotes || ""
                                );
                            }}
                        />
                        <div
                            style={{
                                fontSize: "18px",
                                color: "#1E1E1E",
                                fontWeight: "medium",
                                marginLeft: "auto",
                                cursor: "pointer",
                            }}
                            onClick={() => resetReviewQnA()}
                        >
                            <span>Cancel</span>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ReviewQnAModal;
